(() => {
  if (customElements.get('ge-banners')) return;

  class GeBanners extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-banner-track]');
      this.slides = [...this.querySelectorAll('[data-banner-slide]')];
      this.buttons = [...this.querySelectorAll('[data-banner-select]')];
      if (!this.track || !this.slides.length || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.update();
      if (this.slides.length < 2) return;
      this.querySelector('[data-banner-controls]').hidden = false;
      this.addEventListener('click', (event) => {
        const select = event.target.closest('[data-banner-select]');
        const step = event.target.closest('[data-banner-step]');
        if (select) this.goTo(Number(select.dataset.bannerSelect));
        if (step) this.goTo(this.index + Number(step.dataset.bannerStep));
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (!event.target.closest('[data-banner-controls]') && event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.goTo(index);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (index !== this.index) {
            this.index = Math.max(0, Math.min(this.slides.length - 1, index));
            this.update();
          }
        });
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.goTo(index, false);
      }, options);
    }

    goTo(index, animate = true) {
      const next = (index + this.slides.length) % this.slides.length;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: animate && !reducedMotion ? 'smooth' : 'instant' });
    }

    update() {
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        slide.setAttribute('aria-hidden', String(index !== this.index));
      });
      this.buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.index)));
      const status = this.querySelector('[data-banner-status]');
      if (status) status.textContent = `Banner ${this.index + 1} of ${this.slides.length}: ${this.slides[this.index].dataset.label}`;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('ge-banners', GeBanners);
})();
